import React from "react";
import ClaimsTracker from "./ClaimsTracker";

export default function Claims() {
  return <ClaimsTracker />;
}
